import Layout from '@/views/layout'

export default {
  path: '/outward',
  name: 'Outward',
  meta: {
    id: 'B',
    title: '汇出汇款'
  },
  component: Layout,
  children: [
    {
      path: 'transfer',
      name: 'OutwardTransfer',
      meta: {
        id: '102',
        title: '汇出管理'
      },
      component: () => import('@/views/outward'),
      children: [
        // 跨行汇款
        {
          path: 'inter-bank',
          name: 'InterBankOutward',
          meta: {
            id: '10200300',
            title: '跨行汇款'
          },
          component: () => import('@/views/outward/transfer'),
          redirect: '/outward/transfer/inter-bank/step1',
          children: [
            {
              path: 'step1',
              name: 'InterBankOutwardStep1',
              component: () => import('@/views/outward/transfer/interBank/Step1')
            },
            {
              path: 'step2',
              name: 'InterBankOutwardStep2',
              component: () => import('@/views/outward/transfer/interBank/Step2'),
              meta: {
                title: '信息确认'
              }
            },
            {
              path: 'step3',
              name: 'InterBankOutwardStep3',
              component: () => import('@/views/outward/transfer/interBank/Step3'),
              meta: {
                title: '汇出汇款申报'
              }
            },
            {
              path: 'step4',
              name: 'InterBankOutwardStep4',
              component: () => import('@/views/outward/transfer/interBank/Step4'),
              meta: {
                title: '跨行汇款结果'
              }
            },
            {
              path: 'step5',
              name: 'InterBankOutwardStep5',
              component: () => import('@/views/outward/transfer/interBank/Step5'),
              meta: {
                title: '通知收款方'
              }
            }
          ]
        },
        // 同行汇款
        {
          path: 'inner-bank',
          name: 'InnerBankOutward',
          meta: {
            id: '10200000',
            title: '同行汇款'
          },
          component: () => import('@/views/outward/transfer'),
          redirect: '/outward/transfer/inner-bank/step1',
          children: [
            {
              path: 'step1',
              name: 'InnerBankOutwardStep1',
              component: () => import('@/views/outward/transfer/innerBank/Step1')
            },
            {
              path: 'step2',
              name: 'InnerBankOutwardStep2',
              component: () => import('@/views/outward/transfer/innerBank/Step2')
            },
            {
              path: 'result',
              name: 'InnerBankOutwardResult',
              component: () => import('@/views/outward/transfer/innerBank/TransferResult')
            }
          ]
        },
        // 汇款申报查询
        {
          path: 'declare',
          name: 'DeclareOutward',
          meta: {
            id: '10201100',
            title: '汇款申报查询'
          },
          component: () => import('@/views/outward/transfer'),
          redirect: '/outward/transfer/declare/query',
          children: [
            {
              path: 'query',
              name: 'DeclareOutwardQuery',
              component: () => import('@/views/outward/transfer/declare/Query')
            },
            {
              path: 'add',
              name: 'DeclareOutwardAdd',
              meta: {
                title: '新增汇款申报'
              },
              component: () => import('@/views/outward/transfer/declare/Add')
            },
            {
              path: 'detail',
              name: 'DeclareOutwardDetail',
              meta: {
                title: '汇款申报详情'
              },
              component: () => import('@/views/outward/transfer/declare/Add')
            },
            {
              path: 'update',
              name: 'DeclareOutwardUpdate',
              meta: {
                title: '修改汇款申报'
              },
              component: () => import('@/views/outward/transfer/declare/Add')
            }
          ]
        },
        // 汇款记录查询
        {
          path: 'records',
          name: 'RecordsOutward',
          meta: {
            id: '10200400',
            title: '汇款记录查询'
          },
          redirect: '/outward/transfer/records/list',
          component: () => import('@/views/outward/transfer'),
          children: [
            {
              path: 'list',
              name: 'RecordsOutwardList',
              component: () => import('@/views/outward/transfer/records/list')
            },
            // 汇款记录详情
            {
              path: 'detail',
              name: 'RecordsOutwardDetail',
              meta: {
                title: '汇款记录详情'
              },
              component: () => import('@/views/outward/transfer/records/detail')
            }
          ]
        },
        // 收款人名册
        {
          path: 'payee-list',
          name: 'PayeeListOutward',
          meta: {
            id: '10200500',
            title: '收款人名册'
          },
          component: () => import('@/views/outward/transfer'),
          redirect: '/outward/transfer/payee-list/list',
          children: [
            {
              path: 'list',
              name: 'PayeeListOutwardList',
              meta: {
                title: ''
              },
              component: () => import('@/views/outward/transfer/payeeListOutward/List')
            },
            {
              path: 'details',
              name: 'PayeeListOutwardDetails',
              meta: {
                title: '账户详情'
              },
              component: () => import('@/views/outward/transfer/payeeListOutward/Details')
            },
            {
              path: 'add',
              name: 'PayeeListOutwardAdd',
              meta: {
                title: '添加收款人'
              },
              component: () => import('@/views/outward/transfer/payeeListOutward/Add')
            },
            {
              path: 'modify',
              name: 'PayeeListOutwardModify',
              meta: {
                title: '修改'
              },
              component: () => import('@/views/outward/transfer/payeeListOutward/Modify')
            },
            {
              path: 'add-result',
              name: 'PayeeListOutwardAddResult',
              meta: {
                title: '添加结果'
              },
              component: () => import('@/views/outward/transfer/payeeListOutward/AddResult')
            }
          ]
        }
        // 薪酬发放
        // {
        //   path: 'salary',
        //   name: 'SalaryOutward',
        //   meta: {
        //     id: '20210803',
        //     title: '薪酬发放'
        //   },
        //   component: () => import('@/views/outward/transfer')
        // }
      ]
    }
  ]
}
